import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { RequestService } from "src/app/parametrage/core/service/request.service";
import { Request } from "src/app/parametrage/core/model/request";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RetournerDossierModalComponent } from 'src/app/formulaire/modal/retourner-dossier-modal/retourner-dossier-modal.component';
import { Individual } from 'src/app/parametrage/core/model/individual/individual';
import { IndividualService } from 'src/app/parametrage/core/service/individual.service';

@Component({
  selector: "app-formulaire-layout",
  templateUrl: "./formulaire-layout.component.html",
  styleUrls: ["./formulaire-layout.component.scss"],
})
export class FormulaireLayoutComponent implements OnInit {
  requestId: string;
  taskId: string;

  dossier: Request;

  individual:Individual;

  constructor(
    private _router: Router,
    private modalService: NgbModal,
    private _activatedRoute: ActivatedRoute,
    private _requestService: RequestService,
    private _individualService: IndividualService
  ) {
    console.log("Current URL:", _router.url);

    console.log("requestId:", _router.url.split("/")[3]);
    this.requestId = this._router.url.split("/")[3];

    console.log("taskId:", _router.url.split("/")[4]);
    this.taskId = this._router.url.split("/")[4];
  }

  ngOnInit() {
    this.getRequestById(this.requestId);
    this.getIndividualByRequestId(this.requestId);
  }

  getRequestById(requestId) {
    this._requestService.getRequestById(requestId).subscribe(
      (data) => {
        this.dossier = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getIndividualByRequestId(requestId)
  {
    this._individualService.getIndividualByRequestId(requestId)
    .subscribe(
        data => {
          this.individual =  data;
        },
        error => {
          console.log(error);
        });
  }

  retourner()
  {
    const modalRef = this.modalService.open(RetournerDossierModalComponent,{centered:true});
    modalRef.componentInstance.requestId = this.requestId;

    modalRef.result.then((data) => {
      // on close
      if(data != "Close click"){
        this._router.navigateByUrl("/mon-portefeuille/mes-dossiers");
      }
        
      }, (reason) => {
      // on dismiss
      });

  }


}
